import * as z from 'zod';

import { brandQueryLinkerSchema } from '@/_pages/settings/brands/shared';
import { partnerQueryLinkerSchema } from '@/_pages/settings/partners/shared';
import { companyQueryLinkerSchema } from '@/_schemas/companies/company-query-linker-schema';

import { invoiceBatchItemsSchema } from './invoice-batch-items-schema';
import { invoiceBatchFormSchema } from './invoice-batches-form-schema';

import { invoiceChargeTypeSchema } from '../../invoice-charge-type-options';

export const invoiceBatchCreateFormSchema = z
  .object({
    ...invoiceBatchFormSchema.shape,
    from_date: z.string().nullable(),
    to_date: z.string().nullable(),
    client: companyQueryLinkerSchema.nullable(),
    brand: z.array(brandQueryLinkerSchema).nullable(),
    partner: partnerQueryLinkerSchema.nullable(),
    charge_type: invoiceChargeTypeSchema.nullable(),
    invoices: z.array(invoiceBatchItemsSchema),
  })
  .refine((val) => val.from_date !== null, {
    message: 'From date is required',
    path: ['from_date'],
  })
  .refine((val) => val.to_date !== null, {
    message: 'To date is required',
    path: ['to_date'],
  })
  .refine(
    ({ is_paid, payment_date, inherit_invoice_date_for_payment_date }) => {
      if (is_paid) {
        if (inherit_invoice_date_for_payment_date) {
          return true;
        }
        return payment_date !== null;
      }
      return true;
    },
    {
      message: 'Payment date is required',
      path: ['payment_date'],
    }
  )
  .refine(
    ({ is_paid, payment_method }) => {
      if (is_paid) {
        return payment_method !== null;
      }
      return true;
    },
    {
      message: 'Payment method is required',
      path: ['payment_method'],
    }
  );

export type InvoiceBatchCreateFormSchema = z.infer<typeof invoiceBatchCreateFormSchema>;

export type GetUnbatchedInvoiceAgreementParams = {
  brand_id: string;
  client_id?: number;
  partner_id?: number;
  start_date?: string;
  end_date?: string;
  charge_type?: string;
  invoice_creation_date: string;
  inherit_agreement_creation_date: boolean;
  inherit_invoice_date_for_payment_date: boolean;
};
